type ToggleProps = {
    checked: boolean;
    variant?: "dark" | "light";
    onChange: (checked: boolean) => void;
}

export const Toggle = ({ checked, variant = "dark", onChange }: ToggleProps) => {

    const colorChecked = variant === "dark" ? "bg-osPurple-1" : "bg-pink-mascotte";
    const colorUnchecked = variant === "dark" ? "bg-osPurpleText" : "bg-osGrey-4";
    const colorToggle = variant === "dark" ? "bg-white" : "bg-osBlack";

    return (
        <button
            className={`${checked ? colorChecked : colorUnchecked} rounded-full w-15 h-7 px-1 shrink-0 flex items-center transition-colors duration-200 `}
            style={{
                justifyContent: "flex-" + (checked ? "end" : "start"),
            }}
            onClick={() => onChange(!checked)}
        >
            <div
                className={`${colorToggle} rounded-full w-5 h-5 shrink-0`}
            />
        </button>
    )
}